var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonIconRounded.class,attrs:{"data-tooltip-text":_vm.buttonIconRounded.tooltip,"type":_vm.buttonIconRounded.type},on:{"click":function($event){return _vm.click($event)}}},[(_vm.showLoading)?_c('i',{key:"loadingIcon",staticClass:"fas fa-spinner fa-spin"}):_c('i',{key:"actionIcon",class:_vm.buttonIconRounded.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }